import { render, staticRenderFns } from "./ExpenseForm.vue?vue&type=template&id=1a910b31&scoped=true&"
import script from "./ExpenseForm.vue?vue&type=script&lang=js&"
export * from "./ExpenseForm.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseForm.vue?vue&type=style&index=0&id=1a910b31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a910b31",
  null
  
)

export default component.exports